import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import {
  CountryISO,
  NgxIntlTelInputModule,
  SearchCountryField,
} from 'ngx-intl-tel-input';
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';
import {
  DriverDetailInterface,
  DriverInfoInterface,
} from '../../../core/models';
import { SimpleCheckModalComponent } from '../../modals/simple-check-modal.component';
@Component({
  selector: 'app-driverinfosdrivers',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxIntlTelInputModule,
    SimpleCheckModalComponent,
  ],
  standalone: true,
  template: `
    <div [formGroup]="driver" class="flex flex-row">
      <div
        class="shrink-0 flex flex-col items-start sm:items-end justify-start pr-2 pt-7"
      >
        <button
          (click)="onDelete()"
          type="button"
          class="rounded-md bg-red-500 px-0.5 py-0.5 text-sm font-semibold text-white shadow-xs hover:bg-red-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-500"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="size-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
            />
          </svg>
        </button>
      </div>

      <div class="flex flex-col flex-1 gap-y-3">
        <div class="flex flex-col w-full">
          <label for="driverInfo" class="mb-2 text-sm font-medium text-gray-700"
            >Lenkername</label
          >
          <input
            id="drivername"
            type="text"
            formControlName="driverName"
            class="text-sm sm:text-xs w-full rounded-md border border-gray-300 py-2 px-3 text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            placeholder="Lenkername..."
          />
        </div>

        <div class="w-full">
          <label for="driverTel" class="text-sm font-medium text-gray-700"
            >Lenker Tel</label
          >
          <ngx-intl-tel-input
            [cssClass]="
              'mt-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-columbus-blue-600 sm:text-sm sm:leading-6'
            "
            [preferredCountries]="preferredCountries"
            [enableAutoCountrySelect]="true"
            [enablePlaceholder]="true"
            [searchCountryFlag]="true"
            [searchCountryField]="[
              SearchCountryField.Iso2,
              SearchCountryField.Name,
            ]"
            [selectFirstCountry]="false"
            [selectedCountryISO]="countryCode"
            [phoneValidation]="true"
            [separateDialCode]="true"
            formControlName="driverTel"
          ></ngx-intl-tel-input>
          <div
            *ngIf="
              driver.get('driverTel')?.invalid &&
              driver.get('driverTel')?.touched
            "
            class="text-red-500 text-sm mt-1"
          >
            Valid phone number is required.
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="deleteToggle && inputDriver">
      <app-simple-check-modal
        [message]="'Möchtest du den Lenker entfernen?'"
        [title]="'Lenker entfernen?'"
        [positiveButtonText]="'Yes'"
        [negativeButtonText]="'No'"
        (close)="onDeleteModal($event)"
      ></app-simple-check-modal>
    </div>
  `,
  styles: ``,
})
export class DriverinfosdriversComponent {
  @Input({ required: true }) driver!: FormGroup;
  @Output() delete = new EventEmitter<boolean>();

  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [
    CountryISO.Austria,
    CountryISO.Germany,
    CountryISO.Switzerland,
    CountryISO.Hungary,
    CountryISO.Slovakia,
  ];
  countryCode: CountryISO = CountryISO.Austria;
  PhoneNumberFormat = PhoneNumberFormat;

  deleteToggle = false;
  inputDriver: DriverDetailInterface | undefined = undefined;
  ngOnInit(): void {
    if (this.driver instanceof FormGroup) {
      this.patchDriverTel(this.driver.get('driverTel')?.getRawValue());
      this.inputDriver = this.driver?.getRawValue();
    } else {
      console.error('Driver is not a FormGroup:', this.driver);
    }
  }

  onDeleteToggle() {
    this.deleteToggle = !this.deleteToggle;
  }

  onDelete() {
    this.onDeleteToggle();
  }

  onDeleteModal(value: boolean) {
    if (value) {
      this.delete.emit(true);
    }

    this.onDeleteToggle();
  }

  patchDriverTel(driverTel: string) {
    if (!driverTel) return;

    const phoneUtil = PhoneNumberUtil.getInstance();
    const number = phoneUtil.parse(driverTel, 'ZZ');
    const countryC = phoneUtil.getRegionCodeForNumber(number) as CountryISO;
    driverTel = number.getNationalNumber()?.toString() || '';
    this.countryCode = countryC;
    this.driver.get('driverTel')?.patchValue(driverTel);
  }
}
